import http from '@/plugins/http';
import reportError from '@/utils/reportError';
import jobDetailTransformer from '../../transformers/job/jobDetail';

// When the request succeeds
const success = (response, successCallback) => {
  response = jobDetailTransformer.fetch(response);
  successCallback(response);
};

// When the request fails
const failed = (error, errorCallback) => {
  if (errorCallback) {
    errorCallback(error);
  }
};

export default (job, successCallback, errorCallback, token, id) => {
  const params = {};
  if (token) {
    params.token = token;
  }

  if (id === undefined || id === null) {
    id = job.id;
  }
  http.get(`customer/me/jobs/${id}`, { params })
    .then((response) => {
      success(response.data, successCallback);
    })
    .catch((error) => {
      reportError(error, 'error trying to get job detail');
      failed(error, errorCallback);
    });
};
